 <!-- container -->
<p-blockUI [blocked]="blockedDocument">
 <div class="fixed inset-0 flex flex-col items-center justify-center bg-gray-900/50 z-50">
        <p-progressSpinner></p-progressSpinner>
        <span class="text-white text-lg mt-4">Loading users...</span>
 </div>
</p-blockUI>
<p-toast />
<div>
    <div class="flex flex-col mb-6">
        <h3 class="text-2xl font-bold text-surface-900 dark:text-surface-0 mb-1">System Users</h3>
        <span class="text-surface-500 text-sm">Manage global user accounts. To grant election access, use Election Users within each election.</span>
    </div>

    <div class="mb-6">
    <p-toolbar [style]="{ width: '70w' }">
        <ng-template #start #form>
            <p-iconfield iconPosition="left">
                <p-inputicon styleClass="pi pi-search" />
                <input type="text" [(ngModel)]="name" pInputText placeholder="Search by username" />

            </p-iconfield>
        </ng-template>
        <ng-template #end>

            <p-button (onClick)="showDialog()">New User</p-button>
        </ng-template>
    </p-toolbar>
</div>


@if (users && users.length > 0) {
    <p-table [value]="filteredItems" [tableStyle]="{ 'min-width': '50rem' }"
             [paginator]="true" 
             [rows]="10"
             [rowsPerPageOptions]="[5, 10, 20, 50]">
             
        <ng-template #header>
            <tr>
                <th pSortableColumn="username"> Username<p-sortIcon field="username" /></th>
                <th pSortableColumn="email">Email  <p-sortIcon field="email" /></th>
                <th pSortableColumn="userOrganization.title">Title<p-sortIcon field="title" /></th>
                <th pSortableColumn="userOrganization.organizationName">Organization Name<p-sortIcon field="organizationName" /></th> 
                <th pSortableColumn="roles">System Role  <p-sortIcon field="roles" /></th>
                <th pSortableColumn="signupComplete">Signed Up  <p-sortIcon field="signupComplete" /></th>
                <th pSortableColumn="account.name">Account  <p-sortIcon field="account.name" /></th> 
                <th>Actions</th>                
            </tr>
        </ng-template>
        <ng-template #body let-user>
            <tr>
                <td>{{ user.username }}</td>
                <td>{{ user.email }}</td>
                <td>{{user.userOrganization?.title}}</td>
                <td>{{user.userOrganization?.organizationName}}</td> 
   
                <td>{{ user.roles | role}}</td>
                <td>{{ user.signupComplete | booleanToYesNo}}</td>
                <td>{{ user.account.name }}</td>  
                <td><i class="pi pi-pencil hover:cursor-pointer" (click)="showEditUser(user)" aria-label="Edit user" role="button" tabindex="0" (keydown.enter)="showEditUser(user)" (keydown.space)="$event.preventDefault(); showEditUser(user)"></i>
                    <i class="pi pi-eye ml-3 hover:cursor-pointer" title="View" (click)="showUser(user)" aria-label="View user details" role="button" tabindex="0" (keydown.enter)="showUser(user)" (keydown.space)="$event.preventDefault(); showUser(user)"></i>
                    <i class="pi pi-envelope ml-3 hover:cursor-pointer" (click)="sendPasswordLink(user)" title="Send password reset link" aria-label="Send password reset link" role="button" tabindex="0" (keydown.enter)="sendPasswordLink(user)" (keydown.space)="$event.preventDefault(); sendPasswordLink(user)"></i>
                </td>
            </tr>
        </ng-template>
    </p-table>
    } @else {
        <div class="flex flex-col items-center justify-center py-12 text-center">
            <i class="pi pi-users text-4xl text-surface-400 mb-4"></i>
            <p class="text-lg text-surface-500 mb-4">No users found</p>
            <p-button label="New User" icon="pi pi-plus" (click)="showDialog()"></p-button>
        </div>
    }
    <app-new-user (closeDialog)="closeDialog($event)" [visible]="visible" ></app-new-user>
    <app-edit-user (closeDialog)="closeEditDialog($event)" [visible]="editVisible" [user]="editUser"></app-edit-user>
    <app-user-details (closeDialog)="closeViewDialog($event)" [visible]="viewVisible" [user]="viewUser"></app-user-details>
</div>